import "./packageuslug.css";
export function Services() {
  return (
    <div id="tarif" className="container-fluid p-5">
      <div>
        <h1>Выберите подходящий <span className="textColorSelect">пакет услуг</span></h1>
      </div>
      <div className="row p-3">
        <div className="col-sm-12 col-xxl-4">
          <div class="card mb-3">
            <div class="card-body">
              <h5 class="card-title lined-heading ">Пакет минимум</h5>
              <ul className="card-text">
                <li>
                  <p>Длительность: 30 минут</p>
                </li>
                <li>
                  <p>5-10 фото в цветокоррекции в течении 2-5 дней</p>
                </li>
                <li>
                  <p>Подбор референсов</p>
                </li>
                <li>
                  <p>Подбор локаций</p>
                </li>
                <li>
                  <p>Помощь в подборе образов/реквизита</p>
                </li>
                <li>
                  <p>Помощь в позировании</p>
                </li>
               
              </ul>
              <br></br>
                 <br></br>
              <h4>2 500 рублей</h4>
            
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-xxl-4">
          <div class="card mb-3">
            <div class="card-body">
              <h5 class="card-title lined-heading">Пакет стандарт</h5>
              <ul className="card-text">
                <li>
                  <p>Длительность: 1 час</p>
                </li>
                <li>
                  <p>15-20 фото в цветокоррекции в течении 3-7 дней </p>
                </li>
                <li>
                  <p>Подбор референсов</p>
                </li>
                <li>
                  <p>Подбор локаций</p>
                </li>
                <li>
                  <p>Помощь в подборе образов/реквизита</p>
                </li>
                <li>
                  <p>Помощь в позировании</p>
                </li>
                
              </ul>
              <br></br>
 <br></br>
              <h4>5 000 рублей</h4>
            
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-xxl-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title lined-heading">Пакет премиум</h5>
              <ul className="card-text">
                <li>
                  <p>Длительность: 2 часа</p>
                </li>
                <li>
                  <p>В одной съемке могут участвовать до 5 человек.</p>
                </li>
                <li>
                  <p>20-40 фото в цветокоррекции в течении 5-10 дней</p>
                </li>
                <li>
                  <p>Подбор референсов</p>
                </li>
                <li>
                  <p>Подбор локаций</p>
                </li>
                <li>
                  <p>Помощь в подборе образов/реквизита</p>
                </li>
                <li>
                  <p>Помощь в позировании</p>
                </li>
              
              </ul>

              <h4>7 500 рублей</h4>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
